import { ApiResponse, SubscriptionResponse, UserEmail } from '@arrived/models';

import { api } from './api';
import { unwrapApiResponse } from './utils';

export const postNewPropertyNotificationsSubscription = async (email: UserEmail) => {
  const response = await api.post<ApiResponse<SubscriptionResponse>>(
    '/offerings/notifications/new-properties/subscribe',
    { email }
  );

  return unwrapApiResponse(response.data);
};
